
import { RevList } from '@ds/components/List'
import { RevListItem } from '@ds/components/ListItem'
import isEmpty from 'lodash/isEmpty'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { trackReviewBlockImpression } from '@tracking/events'

import SkeletonUserComment from '../SkeletonUserComment'
import UserComment from '../UserComment'

const NB_REVIEWS_LIMIT = 10

export default {
  components: {
    RevList,
    RevListItem,
    SkeletonUserComment,
    UserComment,
  },

  props: {
    isPending: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: NB_REVIEWS_LIMIT,
    },
    reviews: {
      type: Array,
      default: () => [],
    },
    trackingInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    hasReviews() {
      return this.reviews.length > 0
    },
    placeholderList() {
      return Array.from(Array(this.limit))
    },
  },

  watch: {
    isPending(pending) {
      if (!pending) {
        this.watchReviewInViewport()
      }
    },
  },

  mounted() {
    this.watchReviewInViewport()
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  methods: {
    watchReviewInViewport() {
      if (this.hasReviews && !isEmpty(this.trackingInfo)) {
        this.unobserve = createObserver(this.$el, () => {
          trackReviewBlockImpression(this.trackingInfo)
        })
      }
    },
  },
}
